import { jsx as _jsx } from "react/jsx-runtime";
/**
 * 文档上下文提供者
 * 实现文档上下文的Provider组件
 *
 * 核心功能：
 * 1. 使用状态管理逻辑
 * 2. 提供DocumentContext.Provider
 * 3. 连接状态与上下文
 * 4. 监听文档ID变更事件
 */
import { useEffect } from 'react';
import { useDocumentState } from '../state/index.js';
import { DocumentContext } from './DocumentContext.js';
import { DocumentIdentityService } from '../services/DocumentIdentityService.js';
import { DocumentIdentityEventType } from '@readsavor/types';
import { LoggerService } from '../../logging/services/logger.service.js';
// 为了向后兼容性，重新导出useDocument
import { useDocument } from '../hooks/useDocument.js';
export { useDocument };
/**
 * 文档上下文提供者组件
 * 实现文档管理功能的核心组件
 */
export const DocumentProvider = ({ children }) => {
    // 使用独立的状态管理逻辑
    const documentStateManager = useDocumentState();
    const logger = LoggerService.getInstance().createDomainLogger('DocumentProvider');
    // 添加对DocumentIdentity变更的监听
    useEffect(() => {
        const identityService = DocumentIdentityService.getInstance();
        const handleIdentityChange = (event) => {
            if (event.type === DocumentIdentityEventType.DEACTIVATED) {
                logger.debug('文档ID已停用，重置文档状态');
                documentStateManager.resetDocumentState();
            }
        };
        const removeListener = identityService.addIdentityChangeListener(handleIdentityChange);
        return () => {
            removeListener();
            logger.debug('已移除DocumentIdentity变更监听器');
        };
    }, [documentStateManager, logger]);
    return (_jsx(DocumentContext.Provider, { value: documentStateManager, children: children }));
};
//# sourceMappingURL=DocumentProvider.js.map